<script>

import { cart, mutations } from "./cart";

export default {
    computed: {
        opened: () => cart.opened,
    },
    methods: {
        closeCart() {
            mutations.closeCart();
        }
    }
}
</script>
